export default "__VITE_ASSET__Cmyev9CQ__ 480w, __VITE_ASSET__Bu0YTBdQ__ 768w, __VITE_ASSET__CLVnPjuZ__ 1200w";